var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 33.5,
    r: 27.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9142 20.5858C34.1332 19.8047 32.8668 19.8047 32.0858 20.5858L19.3579 33.3137C18.5768 34.0948 18.5768 35.3611 19.3579 36.1421C20.1389 36.9232 21.4052 36.9232 22.1863 36.1421L33.5 24.8284L44.8137 36.1421C45.5948 36.9232 46.8611 36.9232 47.6421 36.1421C48.4232 35.3611 48.4232 34.0948 47.6421 33.3137L34.9142 20.5858ZM31.5 22V51.5H35.5V22H31.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopButton);
export default __webpack_public_path__ + "static/media/TopButton.5826a4ef787d386a1c8892b36560ef0b.svg";
export { ForwardRef as ReactComponent };